// What happened in a window, newest first, as on the phone (Timeline.kt). Pump records arrive
// already grouped by minute.

import type { EntryDTO, OtherNoteDTO, PumpDTO } from "./dto.js";

export type TimelineRow =
  | { kind: "entry"; key: string; t: number; entry: EntryDTO }
  | { kind: "pump"; key: string; t: number; pump: PumpDTO }
  | { kind: "note"; key: string; t: number; note: OtherNoteDTO };

export function entryKey(entry: EntryDTO): string {
  return `entry:${entry.id}`;
}

export function pumpKey(pump: PumpDTO): string {
  return `pump:${pump.t}`;
}

export function noteKey(note: OtherNoteDTO): string {
  return `note:${note.id ?? note.t}`;
}

/** Newest first; at the same time, entries come before pump rows, then other notes. */
export function timelineRows(data: { entries: EntryDTO[]; pump: PumpDTO[]; notes: OtherNoteDTO[] }): TimelineRow[] {
  const rows: TimelineRow[] = [
    ...data.entries.map((entry): TimelineRow => ({ kind: "entry", key: entryKey(entry), t: entry.t, entry })),
    ...data.pump.map((pump): TimelineRow => ({ kind: "pump", key: pumpKey(pump), t: pump.t, pump })),
    ...data.notes.map((note): TimelineRow => ({ kind: "note", key: noteKey(note), t: note.t, note })),
  ];
  // Array.prototype.sort is stable, which keeps that order for equal times.
  return rows.sort((a, b) => b.t - a.t);
}
